import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import ReservationImg from "../../images/reservation-system.svg"
import ConvenientBookingPageStyle from "./convenient-booking-page.module.scss"

const Reservation = () => (
    <StaticQuery query={graphql`
        query Reservations{
            contentfulConvenientBookingPage{
                convenientBookingReference{
                 sectionContent2{
                    subtitle{
                    subtitle
                    }
                    sectionParagraph{
                        json
                        }
                    }
                }
            }
        }
    `}
    render={data => (
    <div className={ConvenientBookingPageStyle.sectionDiv}>
        <Row className={ConvenientBookingPageStyle.reservationDiv}>
            <Col className={ConvenientBookingPageStyle.reservationCol1} md={5} sm={6}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <ReservationImg className={ConvenientBookingPageStyle.reservationImg} />
                </ScrollAnimation>
            </Col>
            <Col className={ConvenientBookingPageStyle.reservationCol2} md={7} sm={6}>
                <h3 className={ConvenientBookingPageStyle.sectionTitleLeftAlign}>{data.contentfulConvenientBookingPage.convenientBookingReference.sectionContent2.subtitle.subtitle}</h3>
                <div className={ConvenientBookingPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulConvenientBookingPage.convenientBookingReference.sectionContent2.sectionParagraph.json)}
                </div>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default Reservation